import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { connect } from 'react-redux';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

// import { ru } from '../../services/language_ru';
import { en } from '../../services/language_en';

window.langs = new LocalizedStrings({
  // ru,
  en
});

class Page extends Component {
  componentWillReceiveProps(nextProps) {
    const { currentLang } = nextProps;
    const { currentLang:prevLang } = this.props;

    if (currentLang !== prevLang) {
      window.langs.setLanguage(currentLang);
    }
  }

  render() {

    return (
      <div className="page">
        <main className="main">
          <Header />
          {
            this.props.children
          }
        </main>
        <Footer />
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { language } = state;
  return {
    currentLang: language.current,
  };
}

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./src/containers/Page/Page.js